import{useState as e}from"react";function t(){return e({addOffset:()=>{},setOffset:()=>{},dragState:null,defaultBounds:{top:0,bottom:0,left:0,right:0},setSlideIndex:()=>{},nextSlide:()=>{},prevSlide:()=>{},slideIndex:0,maxSlideIndex:0,enableDrag:!0})}export{t as default};
//# sourceMappingURL=index.js.map
